module.exports = __webpack_public_path__ + "static/media/10.42723070.jpg";